import styled from "styled-components";

export const StyledSection = styled.section`
  padding: var(--m-top) 0;
  @media (max-width: 768px) {
    * {
      text-align: center !important;
    }
  }
`;
